import {Component} from '@angular/core';
import {FormBaseComponent, ValidatorService} from '@utils-lib';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {OrgantraegerNichtnatPerson} from '@nachdigal';

@Component({
  selector: 'common-ui-organtraeger-nicht-natuerliche-person',
  templateUrl: './organtraeger-nicht-natuerliche-person.component.html'
})
export class OrgantraegerNichtNatuerlichePersonComponent extends FormBaseComponent<OrgantraegerNichtnatPerson> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      nameOrgantraeger: [this.data.nameOrgantraeger, [
        this.validatorService.required(),
        this.validatorService.maxLength(120)
      ]]
    });
  }
}
